module.exports = __webpack_public_path__ + "img/cover_meg_220.9d76c6f7.webp";